import { JhiEventManager } from '../../ng-jhipster/service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { VideoCallService } from './video-call.service';
import { VideoCallDeleteDialogComponent } from './video-call-delete-dialog.component';
import * as i0 from "@angular/core";
import * as i1 from "./video-call.service";
import * as i2 from "../../ng-jhipster/service";
import * as i3 from "@ng-bootstrap/ng-bootstrap";
import * as i4 from "../../ng-jhipster/language/jhi-translate.directive";
import * as i5 from "@angular/router";
import * as i6 from "@fortawesome/angular-fontawesome";
import * as i7 from "../../shared/alert/alert-error.component";
import * as i8 from "../../shared/alert/alert.component";
import * as i9 from "@angular/common";
function VideoCallComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵelementStart(1, "span", 8);
    i0.ɵɵtext(2, "No videoCalls found");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
const _c0 = function (a1) { return ["/session", a1, "view"]; };
function VideoCallComponent_div_11_tr_39_div_25_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "a", 24);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const videoCall_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction1(2, _c0, videoCall_r3.session == null ? null : videoCall_r3.session.id));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(videoCall_r3.session == null ? null : videoCall_r3.session.id);
} }
const _c1 = function (a1) { return ["/video-call", a1, "view"]; };
const _c2 = function (a1) { return ["/video-call", a1, "edit"]; };
function VideoCallComponent_div_11_tr_39_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td");
    i0.ɵɵelementStart(2, "a", 24);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "td");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "td");
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "td");
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "td");
    i0.ɵɵtext(12);
    i0.ɵɵpipe(13, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "td");
    i0.ɵɵtext(15);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "td");
    i0.ɵɵtext(17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "td");
    i0.ɵɵtext(19);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "td");
    i0.ɵɵtext(21);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(22, "td");
    i0.ɵɵtext(23);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(24, "td");
    i0.ɵɵtemplate(25, VideoCallComponent_div_11_tr_39_div_25_Template, 3, 4, "div", 25);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(26, "td", 26);
    i0.ɵɵelementStart(27, "div", 27);
    i0.ɵɵelementStart(28, "button", 28);
    i0.ɵɵelement(29, "fa-icon", 29);
    i0.ɵɵelementStart(30, "span", 30);
    i0.ɵɵtext(31, "View");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(32, "button", 31);
    i0.ɵɵelement(33, "fa-icon", 32);
    i0.ɵɵelementStart(34, "span", 33);
    i0.ɵɵtext(35, "Edit");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(36, "button", 34);
    i0.ɵɵlistener("click", function VideoCallComponent_div_11_tr_39_Template_button_click_36_listener() { const restoredCtx = i0.ɵɵrestoreView(_r7); const videoCall_r3 = restoredCtx.$implicit; const ctx_r6 = i0.ɵɵnextContext(2); return ctx_r6.delete(videoCall_r3); });
    i0.ɵɵelement(37, "fa-icon", 35);
    i0.ɵɵelementStart(38, "span", 36);
    i0.ɵɵtext(39, "Delete");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const videoCall_r3 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction1(20, _c1, videoCall_r3.id));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(videoCall_r3.id);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(videoCall_r3.externalId);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(videoCall_r3.externalSessionKey);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(10, 14, videoCall_r3.startTime, "medium"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(13, 17, videoCall_r3.endTime, "medium"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(videoCall_r3.status);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(videoCall_r3.duration);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(videoCall_r3.participantsCount);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(videoCall_r3.hasVideo);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(videoCall_r3.hasVoip);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", videoCall_r3.session);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction1(22, _c1, videoCall_r3.id));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction1(24, _c2, videoCall_r3.id));
} }
function VideoCallComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵelementStart(1, "table", 10);
    i0.ɵɵelementStart(2, "thead");
    i0.ɵɵelementStart(3, "tr");
    i0.ɵɵelementStart(4, "th", 11);
    i0.ɵɵelementStart(5, "span", 12);
    i0.ɵɵtext(6, "ID");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "th", 11);
    i0.ɵɵelementStart(8, "span", 13);
    i0.ɵɵtext(9, "External Id");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "th", 11);
    i0.ɵɵelementStart(11, "span", 14);
    i0.ɵɵtext(12, "External Session Key");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "th", 11);
    i0.ɵɵelementStart(14, "span", 15);
    i0.ɵɵtext(15, "Start Time");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "th", 11);
    i0.ɵɵelementStart(17, "span", 16);
    i0.ɵɵtext(18, "End Time");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "th", 11);
    i0.ɵɵelementStart(20, "span", 17);
    i0.ɵɵtext(21, "Status");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(22, "th", 11);
    i0.ɵɵelementStart(23, "span", 18);
    i0.ɵɵtext(24, "Duration");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(25, "th", 11);
    i0.ɵɵelementStart(26, "span", 19);
    i0.ɵɵtext(27, "Participants Count");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(28, "th", 11);
    i0.ɵɵelementStart(29, "span", 20);
    i0.ɵɵtext(30, "Has Video");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(31, "th", 11);
    i0.ɵɵelementStart(32, "span", 21);
    i0.ɵɵtext(33, "Has Voip");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(34, "th", 11);
    i0.ɵɵelementStart(35, "span", 22);
    i0.ɵɵtext(36, "Session");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(37, "th", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(38, "tbody");
    i0.ɵɵtemplate(39, VideoCallComponent_div_11_tr_39_Template, 40, 26, "tr", 23);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(39);
    i0.ɵɵproperty("ngForOf", ctx_r1.videoCalls)("ngForTrackBy", ctx_r1.trackId);
} }
const _c3 = function () { return ["/video-call/new"]; };
export class VideoCallComponent {
    constructor(videoCallService, eventManager, modalService) {
        this.videoCallService = videoCallService;
        this.eventManager = eventManager;
        this.modalService = modalService;
    }
    loadAll() {
        this.videoCallService.query().subscribe((res) => (this.videoCalls = res.body || []));
    }
    ngOnInit() {
        this.loadAll();
        this.registerChangeInVideoCalls();
    }
    ngOnDestroy() {
        if (this.eventSubscriber) {
            this.eventManager.destroy(this.eventSubscriber);
        }
    }
    trackId(index, item) {
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
        return item.id;
    }
    registerChangeInVideoCalls() {
        this.eventSubscriber = this.eventManager.subscribe('videoCallListModification', () => this.loadAll());
    }
    delete(videoCall) {
        const modalRef = this.modalService.open(VideoCallDeleteDialogComponent, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.videoCall = videoCall;
    }
}
VideoCallComponent.ɵfac = function VideoCallComponent_Factory(t) { return new (t || VideoCallComponent)(i0.ɵɵdirectiveInject(i1.VideoCallService), i0.ɵɵdirectiveInject(i2.JhiEventManager), i0.ɵɵdirectiveInject(i3.NgbModal)); };
VideoCallComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: VideoCallComponent, selectors: [["jhi-video-call"]], decls: 12, vars: 4, consts: [["id", "page-heading"], ["jhiTranslate", "inukaNgApp.videoCall.home.title"], ["id", "jh-create-entity", 1, "btn", "btn-primary", "float-right", "jh-create-entity", "create-video-call", 3, "routerLink"], ["icon", "plus"], ["jhiTranslate", "inukaNgApp.videoCall.home.createLabel"], ["class", "alert alert-warning", "id", "no-result", 4, "ngIf"], ["class", "table-responsive", "id", "entities", 4, "ngIf"], ["id", "no-result", 1, "alert", "alert-warning"], ["jhiTranslate", "inukaNgApp.videoCall.home.notFound"], ["id", "entities", 1, "table-responsive"], ["aria-describedby", "page-heading", 1, "table", "table-striped"], ["scope", "col"], ["jhiTranslate", "global.field.id"], ["jhiTranslate", "inukaNgApp.videoCall.externalId"], ["jhiTranslate", "inukaNgApp.videoCall.externalSessionKey"], ["jhiTranslate", "inukaNgApp.videoCall.startTime"], ["jhiTranslate", "inukaNgApp.videoCall.endTime"], ["jhiTranslate", "inukaNgApp.videoCall.status"], ["jhiTranslate", "inukaNgApp.videoCall.duration"], ["jhiTranslate", "inukaNgApp.videoCall.participantsCount"], ["jhiTranslate", "inukaNgApp.videoCall.hasVideo"], ["jhiTranslate", "inukaNgApp.videoCall.hasVoip"], ["jhiTranslate", "inukaNgApp.videoCall.session"], [4, "ngFor", "ngForOf", "ngForTrackBy"], [3, "routerLink"], [4, "ngIf"], [1, "text-right"], [1, "btn-group"], ["type", "submit", 1, "btn", "btn-info", "btn-sm", 3, "routerLink"], ["icon", "eye"], ["jhiTranslate", "entity.action.view", 1, "d-none", "d-md-inline"], ["type", "submit", 1, "btn", "btn-primary", "btn-sm", 3, "routerLink"], ["icon", "pencil-alt"], ["jhiTranslate", "entity.action.edit", 1, "d-none", "d-md-inline"], ["type", "submit", 1, "btn", "btn-danger", "btn-sm", 3, "click"], ["icon", "times"], ["jhiTranslate", "entity.action.delete", 1, "d-none", "d-md-inline"]], template: function VideoCallComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div");
        i0.ɵɵelementStart(1, "h2", 0);
        i0.ɵɵelementStart(2, "span", 1);
        i0.ɵɵtext(3, "Video Calls");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "button", 2);
        i0.ɵɵelement(5, "fa-icon", 3);
        i0.ɵɵelementStart(6, "span", 4);
        i0.ɵɵtext(7, " Create a new Video Call ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(8, "jhi-alert-error");
        i0.ɵɵelement(9, "jhi-alert");
        i0.ɵɵtemplate(10, VideoCallComponent_div_10_Template, 3, 0, "div", 5);
        i0.ɵɵtemplate(11, VideoCallComponent_div_11_Template, 40, 2, "div", 6);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction0(3, _c3));
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("ngIf", (ctx.videoCalls == null ? null : ctx.videoCalls.length) === 0);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.videoCalls && ctx.videoCalls.length > 0);
    } }, directives: [i4.JhiTranslateDirective, i5.RouterLink, i6.FaIconComponent, i7.AlertErrorComponent, i8.AlertComponent, i9.NgIf, i9.NgForOf, i5.RouterLinkWithHref], pipes: [i9.DatePipe], encapsulation: 2 });
